import React from 'react'

import { SVG } from '../../types/svg'

// width="24"
// height="24"
const ArrowLeft = ({ ...props }: SVG) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    enableBackground="new 0 0 24 24"
    viewBox="0 0 24 24"
    fill="#303030"
    {...props}
  >
    <rect fill="none" height="24" width="24" />
    <path d="M9,19l1.41-1.41L5.83,13H22V11H5.83l4.59-4.59L9,5l-7,7L9,19z" />
  </svg>
)

export default ArrowLeft
